import PropTypes from 'prop-types';
import { Box } from '@qga/roo-ui/components';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import { themeGet } from '@styled-system/theme-get';

const pulse = keyframes`
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
`;

const TextBlock = styled(Box)`
  animation: ${pulse} 2s ease-in-out infinite;
  background-color: ${themeGet('colors.greys.alto')};
`;

const PulsingLoadingBlock = ({ height, width, mr, mb, mt, ml, borderRadius }) => (
  <TextBlock
    data-testid="pulsing-loading-block"
    height={height}
    width={width}
    mr={mr}
    mb={mb}
    mt={mt}
    ml={ml}
    borderRadius={borderRadius}
  />
);

const styledSystemPropTypes = PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]);

PulsingLoadingBlock.propTypes = {
  height: styledSystemPropTypes.isRequired,
  width: styledSystemPropTypes.isRequired,
  mb: styledSystemPropTypes,
  mr: styledSystemPropTypes,
  mt: styledSystemPropTypes,
  ml: styledSystemPropTypes,
  borderRadius: styledSystemPropTypes,
};

PulsingLoadingBlock.defaultProps = {
  mb: 2,
  mr: 2,
  mt: 0,
  ml: 0,
  borderRadius: 10,
};

export default PulsingLoadingBlock;
